import { ShoppingCartOutlined } from "@ant-design/icons";
import { type ReactNode } from "react";
import { Typography } from "antd";

const { Paragraph, Text, Title } = Typography;

interface CartEmptyStateProps {
  eyebrow?: ReactNode;
  title?: string;
  description?: ReactNode;
  hint?: ReactNode;
  highlights?: string[];
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
  variant?: "drawer" | "page";
}

export const CartEmptyState = ({
  eyebrow,
  title = "Giỏ hàng đang trống",
  description,
  hint,
  highlights,
  primaryAction,
  secondaryAction,
  variant = "page",
}: CartEmptyStateProps) => (
  <section
    className={`cart-empty-state cart-empty-state--${variant}`}
    aria-label="Giỏ hàng trống"
  >
    <div className="cart-empty-state__visual" aria-hidden="true">
      <span className="cart-empty-state__halo cart-empty-state__halo--primary" />
      <span className="cart-empty-state__halo cart-empty-state__halo--secondary" />
      <span className="cart-empty-state__icon-shell">
        <ShoppingCartOutlined />
      </span>
    </div>

    <div className="cart-empty-state__copy">
      {eyebrow ? (
        <Text className="cart-empty-state__eyebrow">{eyebrow}</Text>
      ) : null}
      {title ? (
        <Title
          className="cart-empty-state__title"
          level={variant === "page" ? 3 : 4}
        >
          {title}
        </Title>
      ) : null}
      {description ? (
        <Paragraph className="cart-empty-state__description" type="secondary">
          {description}
        </Paragraph>
      ) : null}
      {hint ? (
        <Paragraph className="cart-empty-state__hint">{hint}</Paragraph>
      ) : null}
    </div>

    {highlights?.length ? (
      <div className="cart-empty-state__highlights">
        {highlights.map((highlight) => (
          <span key={highlight} className="cart-empty-state__highlight">
            {highlight}
          </span>
        ))}
      </div>
    ) : null}

    {primaryAction || secondaryAction ? (
      <div className="cart-empty-state__actions">
        {primaryAction}
        {secondaryAction}
      </div>
    ) : null}
  </section>
);
